const countryCode = [{
  en: 'Afghanistan',
  cn: '阿富汗',
  code: 'AF',
  zone: '93',
  regex: '^\\+93\\d{8,}$'
}, {
  en: 'Albania',
  cn: '阿尔巴尼亚',
  code: 'AL',
  zone: '355',
  regex: '^\\+355\\d{8,}$'
}, {
  en: 'Algeria',
  cn: '阿尔及利亚',
  code: 'DZ',
  zone: '213',
  regex: '^\\+213\\d{8,}$'
}, {
  en: 'American Samoa',
  cn: '美属萨摩亚',
  code: 'AS',
  zone: '1684',
  regex: '^\\+1684\\d{6,}$'
}, {
  en: 'Andorra',
  cn: '安道尔',
  code: 'AD',
  zone: '376',
  regex: '^\\+376\\d{6,}$'
}, {
  en: 'Angola',
  cn: '安哥拉',
  code: 'AO',
  zone: '244',
  regex: '^\\+244\\d{8,}$'
}, {
  en: 'Anguilla',
  cn: '安圭拉',
  code: 'AI',
  zone: '1264',
  regex: '^\\+1264\\d{6,}$'
}, {
  en: 'Antigua and Barbuda',
  cn: '安提瓜和巴布达',
  code: 'AG',
  zone: '1268',
  regex: '^\\+1268\\d{6,}$'
}, {
  en: 'Argentina',
  cn: '阿根廷',
  code: 'AR',
  zone: '54',
  regex: '^\\+54\\d{8,}$'
}, {
  en: 'Armenia',
  cn: '亚美尼亚',
  code: 'AM',
  zone: '374',
  regex: '^\\+374\\d{8,}$'
}, {
  en: 'Aruba',
  cn: '阿鲁巴',
  code: 'AW',
  zone: '297',
  regex: '^\\+297\\d{6,}$'
}, {
  en: 'Australia',
  cn: '澳大利亚',
  code: 'AU',
  zone: '61',
  regex: '^\\+61\\d{8,}$'
}, {
  en: 'Austria',
  cn: '奥地利',
  code: 'AT',
  zone: '43',
  regex: '^\\+43\\d{8,}$'
}, {
  en: 'Azerbaijan',
  cn: '阿塞拜疆',
  code: 'AZ',
  zone: '994',
  regex: '^\\+994\\d{8,}$'
}, {
  en: 'Bahamas',
  cn: '巴哈马',
  code: 'BS',
  zone: '1242',
  regex: '^\\+1242\\d{6,}$'
}, {
  en: 'Bahrain',
  cn: '巴林',
  code: 'BH',
  zone: '973',
  regex: '^\\+973\\d{8,}$'
}, {
  en: 'Bangladesh',
  cn: '孟加拉国',
  code: 'BD',
  zone: '880',
  regex: '^\\+880\\d{8,}$'
}, {
  en: 'Barbados',
  cn: '巴巴多斯',
  code: 'BB',
  zone: '1246',
  regex: '^\\+1246\\d{6,}$'
}, {
  en: 'Belarus',
  cn: '白俄罗斯',
  code: 'BY',
  zone: '375',
  regex: '^\\+375\\d{8,}$'
}, {
  en: 'Belgium',
  cn: '比利时',
  code: 'BE',
  zone: '32',
  regex: '^\\+32\\d{8,}$'
}, {
  en: 'Belize',
  cn: '伯利兹',
  code: 'BZ',
  zone: '501',
  regex: '^\\+501\\d{6,}$'
}, {
  en: 'Benin',
  cn: '贝宁',
  code: 'BJ',
  zone: '229',
  regex: '^\\+229\\d{8,}$'
}, {
  en: 'Bermuda',
  cn: '百慕大群岛',
  code: 'BM',
  zone: '1441',
  regex: '^\\+1441\\d{6,}$'
}, {
  en: 'Bhutan',
  cn: '不丹',
  code: 'BT',
  zone: '975',
  regex: '^\\+975\\d{7,}$'
}, {
  en: 'Bolivia',
  cn: '玻利维亚',
  code: 'BO',
  zone: '591',
  regex: '^\\+591\\d{8,}$'
}, {
  en: 'BiH',
  cn: '波斯尼亚和黑塞哥维那',
  code: 'BA',
  zone: '387',
  regex: '^\\+387\\d{8,}$'
}, {
  en: 'Botswana',
  cn: '博茨瓦纳',
  code: 'BW',
  zone: '267',
  regex: '^\\+267\\d{8,}$'
}, {
  en: 'Brazil',
  cn: '巴西',
  code: 'BR',
  zone: '55',
  regex: '^\\+55\\d{8,}$'
}, {
  en: 'Brunei',
  cn: '文莱',
  code: 'BN',
  zone: '673',
  regex: '^\\+673\\d{6,}$'
}, {
  en: 'Bulgaria',
  cn: '保加利亚',
  code: 'BG',
  zone: '359',
  regex: '^\\+359\\d{8,}$'
}, {
  en: 'Burkina Faso',
  cn: '布基纳法索',
  code: 'BF',
  zone: '226',
  regex: '^\\+226\\d{8,}$'
}, {
  en: 'Burundi',
  cn: '布隆迪',
  code: 'BI',
  zone: '257',
  regex: '^\\+257\\d{8,}$'
}, {
  en: 'Cambodia',
  cn: '柬埔寨',
  code: 'KH',
  zone: '855',
  regex: '^\\+855\\d{8,}$'
}, {
  en: 'Cameroon',
  cn: '喀麦隆',
  code: 'CM',
  zone: '237',
  regex: '^\\+237\\d{8,}$'
}, {
  en: 'Canada',
  cn: '加拿大',
  code: 'CA',
  zone: '1',
  regex: '^\\+1\\d{10,}$'
}, {
  en: 'Cape Verde',
  cn: '开普',
  code: 'CV',
  zone: '238',
  regex: '^\\+238\\d{7,}$'
}, {
  en: 'Cayman Islands',
  cn: '开曼群岛',
  code: 'KY',
  zone: '1345',
  regex: '^\\+1345\\d{5,}$'
}, {
  en: 'Central African Republic',
  cn: '中非共和国',
  code: 'CF',
  zone: '236',
  regex: '^\\+236\\d{8,}$'
}, {
  en: 'Chad',
  cn: '乍得',
  code: 'TD',
  zone: '235',
  regex: '^\\+235\\d{8,}$'
}, {
  en: 'Chile',
  cn: '智利',
  code: 'CL',
  zone: '56',
  regex: '^\\+56\\d{8,}$'
}, {
  en: 'China',
  cn: '中国大陆',
  code: 'cn',
  zone: '86',
  regex: '^\\+86\\d{11}$'
}, {
  en: 'Colombia',
  cn: '哥伦比亚',
  code: 'CO',
  zone: '57',
  regex: '^\\+57\\d{8,}$'
}, {
  en: 'Comoros',
  cn: '科摩罗',
  code: 'KM',
  zone: '269',
  regex: '^\\+269\\d{7,}$'
}, {
  en: 'Cook Islands',
  cn: '库克群岛',
  code: 'CK',
  zone: '682',
  regex: '^\\+682\\d{5,}$'
}, {
  en: 'Costa Rica',
  cn: '哥斯达黎加',
  code: 'CR',
  zone: '506',
  regex: '^\\+506\\d{8,}$'
}, {
  en: 'Croatia',
  cn: '克罗地亚',
  code: 'HR',
  zone: '385',
  regex: '^\\+385\\d{8,}$'
}, {
  en: 'Cuba',
  cn: '古巴',
  code: 'CU',
  zone: '53',
  regex: '^\\+53\\d{8,}$'
}, {
  en: 'Curacao',
  cn: '库拉索',
  code: 'CW',
  zone: '599',
  regex: '^\\+599\\d{7,}$'
}, {
  en: 'Cyprus',
  cn: '塞浦路斯',
  code: 'CY',
  zone: '357',
  regex: '^\\+357\\d{8,}$'
}, {
  en: 'Czech',
  cn: '捷克',
  code: 'CZ',
  zone: '420',
  regex: '^\\+420\\d{8,}$'
}, {
  en: 'DRC',
  cn: '刚果民主共和国',
  code: 'CD',
  zone: '243',
  regex: '^\\+243\\d{8,}$'
}, {
  en: 'Denmark',
  cn: '丹麦',
  code: 'DK',
  zone: '45',
  regex: '^\\+45\\d{8,}$'
}, {
  en: 'Djibouti',
  cn: '吉布提',
  code: 'DJ',
  zone: '253',
  regex: '^\\+253\\d{7,}$'
}, {
  en: 'Dominica',
  cn: '多米尼加',
  code: 'DM',
  zone: '1767',
  regex: '^\\+1767\\d{7,}$'
}, {
  en: 'Dominican Republic',
  cn: '多米尼加共和国',
  code: 'DO',
  zone: '1809',
  regex: '^\\+1809\\d{7,}$'
}, {
  en: 'Ecuador',
  cn: '厄瓜多尔',
  code: 'EC',
  zone: '593',
  regex: '^\\+593\\d{8,}$'
}, {
  en: 'Egypt',
  cn: '埃及',
  code: 'EG',
  zone: '20',
  regex: '^\\+20\\d{8,}$'
}, {
  en: 'El Salvador',
  cn: '萨尔瓦多',
  code: 'SV',
  zone: '503',
  regex: '^\\+503\\d{8,}$'
}, {
  en: 'Equatorial Guinea',
  cn: '赤道几内亚',
  code: 'GQ',
  zone: '240',
  regex: '^\\+240\\d{7,}$'
}, {
  en: 'Eritrea',
  cn: '厄立特里亚',
  code: 'ER',
  zone: '291',
  regex: '^\\+291\\d{7,}$'
}, {
  en: 'Estonia',
  cn: '爱沙尼亚',
  code: 'EE',
  zone: '372',
  regex: '^\\+372\\d{7,}$'
}, {
  en: 'Ethiopia',
  cn: '埃塞俄比亚',
  code: 'ET',
  zone: '251',
  regex: '^\\+251\\d{8,}$'
}, {
  en: 'Faroe Islands',
  cn: '法罗群岛',
  code: 'FO',
  zone: '298',
  regex: '^\\+298\\d{6,}$'
}, {
  en: 'Fiji',
  cn: '斐济',
  code: 'FJ',
  zone: '679',
  regex: '^\\+679\\d{7,}$'
}, {
  en: 'Finland',
  cn: '芬兰',
  code: 'FI',
  zone: '358',
  regex: '^\\+358\\d{8,}$'
}, {
  en: 'France',
  cn: '法国',
  code: 'FR',
  zone: '33',
  regex: '^\\+33\\d{9,}$'
}, {
  en: 'French Guiana',
  cn: '法属圭亚那',
  code: 'GF',
  zone: '594',
  regex: '^\\+594\\d{6,}$'
}, {
  en: 'French Polynesia',
  cn: '法属波利尼西亚',
  code: 'PF',
  zone: '689',
  regex: '^\\+689\\d{6,}$'
}, {
  en: 'Gabon',
  cn: '加蓬',
  code: 'GA',
  zone: '241',
  regex: '^\\+241\\d{7,}$'
}, {
  en: 'Gambia',
  cn: '冈比亚',
  code: 'GM',
  zone: '220',
  regex: '^\\+220\\d{7,}$'
}, {
  en: 'Georgia',
  cn: '格鲁吉亚',
  code: 'GE',
  zone: '995',
  regex: '^\\+995\\d{8,}$'
}, {
  en: 'Germany',
  cn: '德国',
  code: 'DE',
  zone: '49',
  regex: '^\\+49\\d{10,}$'
}, {
  en: 'Ghana',
  cn: '加纳',
  code: 'GH',
  zone: '233',
  regex: '^\\+233\\d{8,}$'
}, {
  en: 'Gibraltar',
  cn: '直布罗陀',
  code: 'GI',
  zone: '350',
  regex: '^\\+350\\d{8,}$'
}, {
  en: 'Greece',
  cn: '希腊',
  code: 'GR',
  zone: '30',
  regex: '^\\+30\\d{9,}$'
}, {
  en: 'Greenland',
  cn: '格陵兰岛',
  code: 'GL',
  zone: '299',
  regex: '^\\+299\\d{6,}$'
}, {
  en: 'Grenada',
  cn: '格林纳达',
  code: 'GD',
  zone: '1473',
  regex: '^\\+1473\\d{7,}$'
}, {
  en: 'Guadeloupe',
  cn: '瓜德罗普岛',
  code: 'GP',
  zone: '590',
  regex: '^\\+590\\d{6,}$'
}, {
  en: 'Guam',
  cn: '关岛',
  code: 'GU',
  zone: '1671',
  regex: '^\\+1671\\d{7,}$'
}, {
  en: 'Guatemala',
  cn: '瓜地马拉',
  code: 'GT',
  zone: '502',
  regex: '^\\+502\\d{8,}$'
}, {
  en: 'Guinea',
  cn: '几内亚',
  code: 'GN',
  zone: '224',
  regex: '^\\+224\\d{8,}$'
}, {
  en: 'Guinea-Bissau',
  cn: '几内亚比绍共和国',
  code: 'GW',
  zone: '245',
  regex: '^\\+245\\d{7,}$'
}, {
  en: 'Guyana',
  cn: '圭亚那',
  code: 'GY',
  zone: '592',
  regex: '^\\+592\\d{7,}$'
}, {
  en: 'Haiti',
  cn: '海地',
  code: 'HT',
  zone: '509',
  regex: '^\\+509\\d{8,}$'
}, {
  en: 'Honduras',
  cn: '洪都拉斯',
  code: 'HN',
  zone: '504',
  regex: '^\\+504\\d{8,}$'
}, {
  en: 'Hong Kong',
  cn: '中国香港',
  code: 'HK',
  zone: '852',
  regex: '^\\+852\\d{8}$'
}, {
  en: 'Hungary',
  cn: '匈牙利',
  code: 'HU',
  zone: '36',
  regex: '^\\+36\\d{8,}$'
}, {
  en: 'Iceland',
  cn: '冰岛',
  code: 'IS',
  zone: '354',
  regex: '^\\+354\\d{7,}$'
}, {
  en: 'India',
  cn: '印度',
  code: 'IN',
  zone: '91',
  regex: '^\\+91\\d{10}$'
}, {
  en: 'Indonesia',
  cn: '印度尼西亚',
  code: 'ID',
  zone: '62',
  regex: '^\\+62\\d{8,}$'
}, {
  en: 'Iran',
  cn: '伊朗',
  code: 'IR',
  zone: '98',
  regex: '^\\+98\\d{9,}$'
}, {
  en: 'Iraq',
  cn: '伊拉克',
  code: 'IQ',
  zone: '964',
  regex: '^\\+964\\d{8,}$'
}, {
  en: 'Ireland',
  cn: '爱尔兰',
  code: 'IE',
  zone: '353',
  regex: '^\\+353\\d{8,}$'
}, {
  en: 'Israel',
  cn: '以色列',
  code: 'IL',
  zone: '972',
  regex: '^\\+972\\d{9,}$'
}, {
  en: 'Italy',
  cn: '意大利',
  code: 'IT',
  zone: '39',
  regex: '^\\+39\\d{9,}$'
}, {
  en: 'Ivory Coast',
  cn: '象牙海岸',
  code: 'CI',
  zone: '225',
  regex: '^\\+225\\d{8,}$'
}, {
  en: 'Jamaica',
  cn: '牙买加',
  code: 'JM',
  zone: '1876',
  regex: '^\\+1876\\d{7,}$'
}, {
  en: 'Japan',
  cn: '日本',
  code: 'JP',
  zone: '81',
  regex: '^\\+81\\d{9,}$'
}, {
  en: 'Jordan',
  cn: '约旦',
  code: 'JO',
  zone: '962',
  regex: '^\\+962\\d{8,}$'
}, {
  en: 'Kazakhstan',
  cn: '哈萨克斯坦',
  code: 'KZ',
  zone: '7',
  regex: '^\\+7\\d{10}$'
}, {
  en: 'Kenya',
  cn: '肯尼亚',
  code: 'KE',
  zone: '254',
  regex: '^\\+254\\d{9,}$'
}, {
  en: 'Kiribati',
  cn: '基里巴斯',
  code: 'KI',
  zone: '686',
  regex: '^\\+686\\d{5,}$'
}, {
  en: 'Kuwait',
  cn: '科威特',
  code: 'KW',
  zone: '965',
  regex: '^\\+965\\d{8,}$'
}, {
  en: 'Kyrgyzstan',
  cn: '吉尔吉斯斯坦',
  code: 'KG',
  zone: '996',
  regex: '^\\+996\\d{8,}$'
}, {
  en: 'Laos',
  cn: '老挝',
  code: 'LA',
  zone: '856',
  regex: '^\\+856\\d{8,}$'
}, {
  en: 'Latvia',
  cn: '拉脱维亚',
  code: 'LV',
  zone: '371',
  regex: '^\\+371\\d{8,}$'
}, {
  en: 'Lebanon',
  cn: '黎巴嫩',
  code: 'LB',
  zone: '961',
  regex: '^\\+961\\d{8,}$'
}, {
  en: 'Lesotho',
  cn: '莱索托',
  code: 'LS',
  zone: '266',
  regex: '^\\+266\\d{8,}$'
}, {
  en: 'Liberia',
  cn: '利比里亚',
  code: 'LR',
  zone: '231',
  regex: '^\\+231\\d{7,}$'
}, {
  en: 'Libya',
  cn: '利比亚',
  code: 'LY',
  zone: '218',
  regex: '^\\+218\\d{8,}$'
}, {
  en: 'Liechtenstein',
  cn: '列支敦士登',
  code: 'LI',
  zone: '423',
  regex: '^\\+423\\d{7,}$'
}, {
  en: 'Lithuania',
  cn: '立陶宛',
  code: 'LT',
  zone: '370',
  regex: '^\\+370\\d{8,}$'
}, {
  en: 'Luxembourg',
  cn: '卢森堡',
  code: 'LU',
  zone: '352',
  regex: '^\\+352\\d{8,}$'
}, {
  en: 'Macau',
  cn: '中国澳门',
  code: 'MO',
  zone: '853',
  regex: '^\\+853\\d{8}$'
}, {
  en: 'Macedonia',
  cn: '马其顿',
  code: 'MK',
  zone: '389',
  regex: '^\\+389\\d{8,}$'
}, {
  en: 'Madagascar',
  cn: '马达加斯加',
  code: 'MG',
  zone: '261',
  regex: '^\\+261\\d{8,}$'
}, {
  en: 'Malawi',
  cn: '马拉维',
  code: 'MW',
  zone: '265',
  regex: '^\\+265\\d{8,}$'
}, {
  en: 'Malaysia',
  cn: '马来西亚',
  code: 'MY',
  zone: '60',
  regex: '^\\+60\\d{8,}$'
}, {
  en: 'Maldives',
  cn: '马尔代夫',
  code: 'MV',
  zone: '960',
  regex: '^\\+960\\d{7,}$'
}, {
  en: 'Mali',
  cn: '马里',
  code: 'ML',
  zone: '223',
  regex: '^\\+223\\d{8,}$'
}, {
  en: 'Malta',
  cn: '马耳他',
  code: 'MT',
  zone: '356',
  regex: '^\\+356\\d{8,}$'
}, {
  en: 'Martinique',
  cn: '马提尼克',
  code: 'MQ',
  zone: '596',
  regex: '^\\+596\\d{6,}$'
}, {
  en: 'Mauritania',
  cn: '毛里塔尼亚',
  code: 'MR',
  zone: '222',
  regex: '^\\+222\\d{8,}$'
}, {
  en: 'Mauritius',
  cn: '毛里求斯',
  code: 'MU',
  zone: '230',
  regex: '^\\+230\\d{7,}$'
}, {
  en: 'Mayotte',
  cn: '马约特',
  code: 'YT',
  zone: '269',
  regex: '^\\+269\\d{7,}$'
}, {
  en: 'Mexico',
  cn: '墨西哥',
  code: 'MX',
  zone: '52',
  regex: '^\\+52\\d{10,}$'
}, {
  en: 'Moldova',
  cn: '摩尔多瓦',
  code: 'MD',
  zone: '373',
  regex: '^\\+373\\d{8,}$'
}, {
  en: 'Monaco',
  cn: '摩纳哥',
  code: 'MC',
  zone: '377',
  regex: '^\\+377\\d{8,}$'
}, {
  en: 'Mongolia',
  cn: '蒙古',
  code: 'MN',
  zone: '976',
  regex: '^\\+976\\d{8,}$'
}, {
  en: 'Montenegro',
  cn: '黑山',
  code: 'ME',
  zone: '382',
  regex: '^\\+382\\d{8,}$'
}, {
  en: 'Montserrat',
  cn: '蒙特塞拉特岛',
  code: 'MS',
  zone: '1664',
  regex: '^\\+1664\\d{7,}$'
}, {
  en: 'Morocco',
  cn: '摩洛哥',
  code: 'MA',
  zone: '212',
  regex: '^\\+212\\d{8,}$'
}, {
  en: 'Mozambique',
  cn: '莫桑比克',
  code: 'MZ',
  zone: '258',
  regex: '^\\+258\\d{8,}$'
}, {
  en: 'Myanmar',
  cn: '缅甸',
  code: 'MM',
  zone: '95',
  regex: '^\\+95\\d{8,}$'
}, {
  en: 'Namibia',
  cn: '纳米比亚',
  code: 'NA',
  zone: '264',
  regex: '^\\+264\\d{8,}$'
}, {
  en: 'Nepal',
  cn: '尼泊尔',
  code: 'NP',
  zone: '977',
  regex: '^\\+977\\d{8,}$'
}, {
  en: 'Netherlands',
  cn: '荷兰',
  code: 'NL',
  zone: '31',
  regex: '^\\+31\\d{9,}$'
}, {
  en: 'New Caledonia',
  cn: '新喀里多尼亚',
  code: 'NC',
  zone: '687',
  regex: '^\\+687\\d{6,}$'
}, {
  en: 'New Zealand',
  cn: '新西兰',
  code: 'NZ',
  zone: '64',
  regex: '^\\+64\\d{9,}$'
}, {
  en: 'Nicaragua',
  cn: '尼加拉瓜',
  code: 'NI',
  zone: '505',
  regex: '^\\+505\\d{8,}$'
}, {
  en: 'Niger',
  cn: '尼日尔',
  code: 'NE',
  zone: '227',
  regex: '^\\+227\\d{8,}$'
}, {
  en: 'Nigeria',
  cn: '尼日利亚',
  code: 'NG',
  zone: '234',
  regex: '^\\+234\\d{10}$'
}, {
  en: 'Norway',
  cn: '挪威',
  code: 'NO',
  zone: '47',
  regex: '^\\+47\\d{8,}$'
}, {
  en: 'Oman',
  cn: '阿曼',
  code: 'OM',
  zone: '968',
  regex: '^\\+968\\d{8,}$'
}, {
  en: 'Pakistan',
  cn: '巴基斯坦',
  code: 'PK',
  zone: '92',
  regex: '^\\+92\\d{10}$'
}, {
  en: 'Palau',
  cn: '帕劳',
  code: 'PW',
  zone: '680',
  regex: '^\\+680\\d{6,}$'
}, {
  en: 'Palestine',
  cn: '巴勒斯坦',
  code: 'BL',
  zone: '970',
  regex: '^\\+970\\d{8,}$'
}, {
  en: 'Panama',
  cn: '巴拿马',
  code: 'PA',
  zone: '507',
  regex: '^\\+507\\d{8,}$'
}, {
  en: 'Papua New Guinea',
  cn: '巴布亚新几内亚',
  code: 'PG',
  zone: '675',
  regex: '^\\+675\\d{7,}$'
}, {
  en: 'Paraguay',
  cn: '巴拉圭',
  code: 'PY',
  zone: '595',
  regex: '^\\+595\\d{8,}$'
}, {
  en: 'Peru',
  cn: '秘鲁',
  code: 'PE',
  zone: '51',
  regex: '^\\+51\\d{8,}$'
}, {
  en: 'Philippines',
  cn: '菲律宾',
  code: 'PH',
  zone: '63',
  regex: '^\\+63\\d{10}$'
}, {
  en: 'Poland',
  cn: '波兰',
  code: 'PL',
  zone: '48',
  regex: '^\\+48\\d{9,}$'
}, {
  en: 'Portugal',
  cn: '葡萄牙',
  code: 'PT',
  zone: '351',
  regex: '^\\+351\\d{9,}$'
}, {
  en: 'Puerto Rico',
  cn: '波多黎各',
  code: 'PR',
  zone: '1787',
  regex: '^\\+1787\\d{7,}$'
}, {
  en: 'Qatar',
  cn: '卡塔尔',
  code: 'QA',
  zone: '974',
  regex: '^\\+974\\d{8,}$'
}, {
  en: 'Republic Of The Congo',
  cn: '刚果共和国',
  code: 'CG',
  zone: '242',
  regex: '^\\+242\\d{7,}$'
}, {
  en: 'Réunion Island',
  cn: '留尼汪',
  code: 'RE',
  zone: '262',
  regex: '^\\+262\\d{7,}$'
}, {
  en: 'Romania',
  cn: '罗马尼亚',
  code: 'RO',
  zone: '40',
  regex: '^\\+40\\d{9,}$'
}, {
  en: 'Russia',
  cn: '俄罗斯',
  code: 'RU',
  zone: '7',
  regex: '^\\+7\\d{10}$'
}, {
  en: 'Rwanda',
  cn: '卢旺达',
  code: 'RW',
  zone: '250',
  regex: '^\\+250\\d{8,}$'
}, {
  en: 'Saint Kitts and Nevis',
  cn: '圣基茨和尼维斯',
  code: 'KN',
  zone: '1869',
  regex: '^\\+1869\\d{7,}$'
}, {
  en: 'Saint Lucia',
  cn: '圣露西亚',
  code: 'LC',
  zone: '1758',
  regex: '^\\+1758\\d{7,}$'
}, {
  en: 'Saint Pierre and Miquelon',
  cn: '圣彼埃尔和密克隆岛',
  code: 'PM',
  zone: '508',
  regex: '^\\+508\\d{6,}$'
}, {
  en: 'Saint Vincent and The Grenadines',
  cn: '圣文森特和格林纳丁斯',
  code: 'VC',
  zone: '1784',
  regex: '^\\+1784\\d{7,}$'
}, {
  en: 'Samoa',
  cn: '萨摩亚',
  code: 'WS',
  zone: '685',
  regex: '^\\+685\\d{6,}$'
}, {
  en: 'San Marino',
  cn: '圣马力诺',
  code: 'SM',
  zone: '378',
  regex: '^\\+378\\d{7,}$'
}, {
  en: 'Sao Tome and Principe',
  cn: '圣多美和普林西比',
  code: 'ST',
  zone: '239',
  regex: '^\\+239\\d{7,}$'
}, {
  en: 'Saudi Arabia',
  cn: '沙特阿拉伯',
  code: 'SA',
  zone: '966',
  regex: '^\\+966\\d{9,}$'
}, {
  en: 'Senegal',
  cn: '塞内加尔',
  code: 'SN',
  zone: '221',
  regex: '^\\+221\\d{8,}$'
}, {
  en: 'Serbia',
  cn: '塞尔维亚',
  code: 'RS',
  zone: '381',
  regex: '^\\+381\\d{8,}$'
}, {
  en: 'Seychelles',
  cn: '塞舌尔',
  code: 'SC',
  zone: '248',
  regex: '^\\+248\\d{7,}$'
}, {
  en: 'Sierra Leone',
  cn: '塞拉利昂',
  code: 'SL',
  zone: '232',
  regex: '^\\+232\\d{8,}$'
}, {
  en: 'Singapore',
  cn: '新加坡',
  code: 'SG',
  zone: '65',
  regex: '^\\+65\\d{8}$'
}, {
  en: 'Saint Maarten (Dutch Part)',
  cn: '圣马丁岛（荷兰部分）',
  code: 'SX',
  zone: '1721',
  regex: '^\\+1721\\d{7,}$'
}, {
  en: 'Slovakia',
  cn: '斯洛伐克',
  code: 'SK',
  zone: '421',
  regex: '^\\+421\\d{9,}$'
}, {
  en: 'Slovenia',
  cn: '斯洛文尼亚',
  code: 'SI',
  zone: '386',
  regex: '^\\+386\\d{8,}$'
}, {
  en: 'Solomon Islands',
  cn: '所罗门群岛',
  code: 'SB',
  zone: '677',
  regex: '^\\+677\\d{5,}$'
}, {
  en: 'Somalia',
  cn: '索马里',
  code: 'SO',
  zone: '252',
  regex: '^\\+252\\d{8,}$'
}, {
  en: 'South Africa',
  cn: '南非',
  code: 'ZA',
  zone: '27',
  regex: '^\\+27\\d{9,}$'
}, {
  en: 'South Korea',
  cn: '韩国',
  code: 'KR',
  zone: '82',
  regex: '^\\+82\\d{9,}$'
}, {
  en: 'Spain',
  cn: '西班牙',
  code: 'ES',
  zone: '34',
  regex: '^\\+34\\d{9,}$'
}, {
  en: 'Sri Lanka',
  cn: '斯里兰卡',
  code: 'LK',
  zone: '94',
  regex: '^\\+94\\d{8,}$'
}, {
  en: 'Sudan',
  cn: '苏丹',
  code: 'SD',
  zone: '249',
  regex: '^\\+249\\d{8,}$'
}, {
  en: 'Suriname',
  cn: '苏里南',
  code: 'SR',
  zone: '597',
  regex: '^\\+597\\d{7,}$'
}, {
  en: 'Swaziland',
  cn: '斯威士兰',
  code: 'SZ',
  zone: '268',
  regex: '^\\+268\\d{8,}$'
}, {
  en: 'Sweden',
  cn: '瑞典',
  code: 'SE',
  zone: '46',
  regex: '^\\+46\\d{8,}$'
}, {
  en: 'Switzerland',
  cn: '瑞士',
  code: 'CH',
  zone: '41',
  regex: '^\\+41\\d{9,}$'
}, {
  en: 'Syria',
  cn: '叙利亚',
  code: 'SY',
  zone: '963',
  regex: '^\\+963\\d{8,}$'
}, {
  en: 'Taiwan',
  cn: '中国台湾',
  code: 'TW',
  zone: '886',
  regex: '^\\+886\\d{9}$'
}, {
  en: 'Tajikistan',
  cn: '塔吉克斯坦',
  code: 'TJ',
  zone: '992',
  regex: '^\\+992\\d{8,}$'
}, {
  en: 'Tanzania',
  cn: '坦桑尼亚',
  code: 'TZ',
  zone: '255',
  regex: '^\\+255\\d{9,}$'
}, {
  en: 'Thailand',
  cn: '泰国',
  code: 'TH',
  zone: '66',
  regex: '^\\+66\\d{9,}$'
}, {
  en: 'Timor-Leste',
  cn: '东帝汶',
  code: 'TL',
  zone: '670',
  regex: '^\\+670\\d{7,}$'
}, {
  en: 'Togo',
  cn: '多哥',
  code: 'TG',
  zone: '228',
  regex: '^\\+228\\d{8,}$'
}, {
  en: 'Tonga',
  cn: '汤加',
  code: 'TO',
  zone: '676',
  regex: '^\\+676\\d{6,}$'
}, {
  en: 'Trinidad and Tobago',
  cn: '特立尼达和多巴哥',
  code: 'TT',
  zone: '1868',
  regex: '^\\+1868\\d{7,}$'
}, {
  en: 'Tunisia',
  cn: '突尼斯',
  code: 'TN',
  zone: '216',
  regex: '^\\+216\\d{8,}$'
}, {
  en: 'Turkey',
  cn: '土耳其',
  code: 'TR',
  zone: '90',
  regex: '^\\+90\\d{9,}$'
}, {
  en: 'Turkmenistan',
  cn: '土库曼斯坦',
  code: 'TM',
  zone: '993',
  regex: '^\\+993\\d{8,}$'
}, {
  en: 'Turks and Caicos Islands',
  cn: '特克斯和凯科斯群岛',
  code: 'TC',
  zone: '1649',
  regex: '^\\+1649\\d{7,}$'
}, {
  en: 'Uganda',
  cn: '乌干达',
  code: 'UG',
  zone: '256',
  regex: '^\\+256\\d{9,}$'
}, {
  en: 'Ukraine',
  cn: '乌克兰',
  code: 'UA',
  zone: '380',
  regex: '^\\+380\\d{9,}$'
}, {
  en: 'United Arab Emirates',
  cn: '阿拉伯联合酋长国',
  code: 'AE',
  zone: '971',
  regex: '^\\+971\\d{9,}$'
}, {
  en: 'United Kingdom',
  cn: '英国',
  code: 'GB',
  zone: '44',
  regex: '^\\+44\\d{10}$'
}, {
  en: 'United States',
  cn: '美国',
  code: 'US',
  zone: '1',
  regex: '^\\+1\\d{10}$'
}, {
  en: 'Uruguay',
  cn: '乌拉圭',
  code: 'UY',
  zone: '598',
  regex: '^\\+598\\d{8,}$'
}, {
  en: 'Uzbekistan',
  cn: '乌兹别克斯坦',
  code: 'UZ',
  zone: '998',
  regex: '^\\+998\\d{9,}$'
}, {
  en: 'Vanuatu',
  cn: '瓦努阿图',
  code: 'VU',
  zone: '678',
  regex: '^\\+678\\d{7,}$'
}, {
  en: 'Venezuela',
  cn: '委内瑞拉',
  code: 'VE',
  zone: '58',
  regex: '^\\+58\\d{10}$'
}, {
  en: 'Vietnam',
  cn: '越南',
  code: 'VN',
  zone: '84',
  regex: '^\\+84\\d{9,}$'
}, {
  en: 'Virgin Islands, British',
  cn: '英属处女群岛',
  code: 'VG',
  zone: '1340',
  regex: '^\\+1340\\d{7,}$'
}, {
  en: 'Virgin Islands, US',
  cn: '美属维尔京群岛',
  code: 'VI',
  zone: '1284',
  regex: '^\\+1284\\d{7,}$'
}, {
  en: 'Yemen',
  cn: '也门',
  code: 'YE',
  zone: '967',
  regex: '^\\+967\\d{7,}$'
}, {
  en: 'Zambia',
  cn: '赞比亚',
  code: 'ZM',
  zone: '260',
  regex: '^\\+260\\d{9,}$'
}, {
  en: 'Zimbabwe',
  cn: '津巴布韦',
  code: 'ZW',
  zone: '263',
  regex: '^\\+263\\d{8,}$'
}]
  export default countryCode